import React, { useState } from "react";
import { motion } from "framer-motion";
import { useCart } from "../../contexts/CartContext";
import "../Checkoutpage/Checkout.css";
import Header from "../Home/Header";

const Checkout = () => {
  const { items, clearCart, } = useCart();
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    address: "",
    phone: "",
    email: "",
    shippingAddress: "",
    payment: "paypal",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Order placed successfully!");
    clearCart();
  };

  const subtotal = items.reduce((total, item) => total + item.price * item.quantity, 0);
  const discount = subtotal * 0.2;
  const total = subtotal - discount;

  return (
    
    <>
    <Header  />
        <div className="checkout-wrapper updated-layout">
      <motion.div
        className="checkout-left"
        initial={{ opacity: 0, x: -30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ duration: 0.5 }}
      >
        <h2 className="checkout-heading">Checkout</h2>
        <form onSubmit={handleSubmit} className="checkout-form">
          <div className="form-section">
            <h3>Billing Information</h3>
            <div className="form-grid">
              <input type="text" name="firstName" placeholder="First Name" value={formData.firstName} onChange={handleChange} required />
              <input type="text" name="lastName" placeholder="Last Name" value={formData.lastName} onChange={handleChange} required />
            </div>
            <input type="text" name="address" placeholder="Address" value={formData.address} onChange={handleChange} required />
            <div className="form-grid">
              <input type="text" name="phone" placeholder="Phone" value={formData.phone} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Email Address" value={formData.email} onChange={handleChange} required />
            </div>
          </div>

          <div className="form-section">
            <h3>Shipping Information</h3>
            <input type="text" name="shippingAddress" placeholder="Shipping Address" value={formData.shippingAddress} onChange={handleChange} required />
          </div>

          <div className="form-section">
            <h3>Payment Method</h3>
            <div className="radio-group">
              <label>
                <input type="radio" name="payment" value="cod" checked={formData.payment === "cod"} onChange={handleChange} />
                Cash on Delivery
              </label>
              <label>
                <input type="radio" name="payment" value="paypal" checked={formData.payment === "paypal"} onChange={handleChange} />
                PayPal
              </label>
            </div>
          </div>
        </form>
      </motion.div>

      <motion.div
        className="checkout-right"
        initial={{ opacity: 0, x: 30 }}
        animate={{ opacity: 1, x: 0 }}
        transition={{ delay: 0.3 }}
      >
        <h3 className="summary-title">Order Summary</h3>
        <ul className="summary-items">
          {items.map((item) => (
            <li key={item.slug} className="summary-item">
              <img src={item.image} alt={item.name} className="summary-img" />
              <div className="summary-info">
                <p className="summary-name">{item.name}</p>
                <p className="summary-qty">Qty: {item.quantity}</p>
              </div>
              <p className="summary-price">${(item.price * item.quantity).toFixed(2)}</p>
            </li>
          ))}
        </ul>

        <div className="summary-totals">
          <p className="summary-line">Subtotal: <span>${subtotal.toFixed(2)}</span></p>
          <p className="summary-line">Discount: <span>-${discount.toFixed(2)}</span></p>
          <p className="summary-line">Shipping: <span>Free</span></p>
          <h4 className="summary-total">Total: <span>${total.toFixed(2)}</span></h4>
        </div>

        <motion.button
          onClick={handleSubmit}
          className="place-order-btn"
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          Place Order
        </motion.button>
      </motion.div>
    </div>
    </>
  );
};

export default Checkout;
